// Import all JSON files statically
import navLinks from './json/nav-links.js';
import p1d66e21 from './json/p-1-d66e21.js';
import tocId_d66e20 from './json/tocId-d66e20.js';
import tocId_d66e69 from './json/tocId-d66e69.js';
import tocId_d66e78 from './json/tocId-d66e78.js';
import tocId_d66e1939 from './json/tocId-d66e1939.js';
import tocId_d66e1988 from './json/tocId-d66e1988.js';
import tocId_d66e2102 from './json/tocId-d66e2102.js';
import tocId_d66e4297 from './json/tocId-d66e4297.js';
import tocId_d66e4298 from './json/tocId-d66e4298.js';
import tocId_d66e4321 from './json/tocId-d66e4321.js';
import tocId_d66e4322 from './json/tocId-d66e4322.js';
import tocId_d66e4428 from './json/tocId-d66e4428.js';
import tocId_d66e4452 from './json/tocId-d66e4452.js';
import tocId_d66e4517 from './json/tocId-d66e4517.js';
import tocId_d66e4541 from './json/tocId-d66e4541.js';
import tocId_d66e4550 from './json/tocId-d66e4550.js';
import tocId_d66e4574 from './json/tocId-d66e4574.js';
import tocId_d66e4809 from './json/tocId-d66e4809.js';
import tocId_d66e4833 from './json/tocId-d66e4833.js';
import tocId_d66e4842 from './json/tocId-d66e4842.js';
import tocId_d66e4859 from './json/tocId-d66e4859.js';
import tocId_d66e4860 from './json/tocId-d66e4860.js';
import tocId_d66e4866 from './json/tocId-d66e4866.js';
import tocId_d66e4883 from './json/tocId-d66e4883.js';
import tocId_d66e4884 from './json/tocId-d66e4884.js';
import tocId_d66e5296 from './json/tocId-d66e5296.js';
import tocId_d66e5320 from './json/tocId-d66e5320.js';
import tocId_d66e5618 from './json/tocId-d66e5618.js';
import tocId_d66e5642 from './json/tocId-d66e5642.js';
import tocId_d66e5780 from './json/tocId-d66e5780.js';
import tocId_d66e5804 from './json/tocId-d66e5804.js';
import tocId_d66e5974 from './json/tocId-d66e5974.js';
import tocId_d66e5998 from './json/tocId-d66e5998.js';
import tocId_d66e6716 from './json/tocId-d66e6716.js';
import tocId_d66e6740 from './json/tocId-d66e6740.js';
import tocId_d66e6773 from './json/tocId-d66e6773.js';
import tocId_d66e6797 from './json/tocId-d66e6797.js';
import tocId_d66e6862 from './json/tocId-d66e6862.js';
import tocId_d66e6886 from './json/tocId-d66e6886.js';
import tocId_d66e7555 from './json/tocId-d66e7555.js';
import tocId_d66e7564 from './json/tocId-d66e7564.js';
import tocId_d66e7579 from './json/tocId-d66e7579.js';
import tocId_d66e7588 from './json/tocId-d66e7588.js';
import tocId_d66e7589 from './json/tocId-d66e7589.js';
import tocId_d66e7613 from './json/tocId-d66e7613.js';
import tocId_d66e7864 from './json/tocId-d66e7864.js';
import tocId_d66e7865 from './json/tocId-d66e7865.js';
import tocId_d66e7866 from './json/tocId-d66e7866.js';
import tocId_d66e7888 from './json/tocId-d66e7888.js';
import tocId_d66e7889 from './json/tocId-d66e7889.js';

// Import all the c- files
import c_Application_d66e5781 from './json/c-Application-d66e5781.js';
import c_Application_d66e5805 from './json/c-Application-d66e5805.js';
import c_Cookie_d66e7590 from './json/c-Cookie-d66e7590.js';
import c_Cookie_d66e7614 from './json/c-Cookie-d66e7614.js';
import c_CurrentOperator_d66e5902 from './json/c-CurrentOperator-d66e5902.js';
import c_CurrentOperator_d66e5926 from './json/c-CurrentOperator-d66e5926.js';
import c_DBEngine_d66e5619 from './json/c-DBEngine-d66e5619.js';
import c_DBEngine_d66e5643 from './json/c-DBEngine-d66e5643.js';
import c_DOMAttr_d66e7443 from './json/c-DOMAttr-d66e7443.js';
import c_DOMAttr_d66e7467 from './json/c-DOMAttr-d66e7467.js';
import c_DOMCharacterData_d66e7491 from './json/c-DOMCharacterData-d66e7491.js';
import c_DOMCharacterData_d66e7515 from './json/c-DOMCharacterData-d66e7515.js';
import c_DOMDocument_d66e6863 from './json/c-DOMDocument-d66e6863.js';
import c_DOMDocument_d66e6887 from './json/c-DOMDocument-d66e6887.js';
import c_DOMElement_d66e7266 from './json/c-DOMElement-d66e7266.js';
import c_DOMElement_d66e7290 from './json/c-DOMElement-d66e7290.js';
import c_DOMNode_d66e7040 from './json/c-DOMNode-d66e7040.js';
import c_DOMNode_d66e7064 from './json/c-DOMNode-d66e7064.js';
import c_Entity_d66e6717 from './json/c-Entity-d66e6717.js';
import c_Entity_d66e6741 from './json/c-Entity-d66e6741.js';
import c_EntityCollection_d66e6733 from './json/c-EntityCollection-d66e6733.js';
import c_EntityCollection_d66e6757 from './json/c-EntityCollection-d66e6757.js';
import c_Enumeration_d66e6596 from './json/c-Enumeration-d66e6596.js';
import c_Enumeration_d66e6620 from './json/c-Enumeration-d66e6620.js';
import c_EnumerationValue_d66e6660 from './json/c-EnumerationValue-d66e6660.js';
import c_EnumerationValue_d66e6684 from './json/c-EnumerationValue-d66e6684.js';
import c_File_d66e4861 from './json/c-File-d66e4861.js';
import c_File_d66e4885 from './json/c-File-d66e4885.js';
import c_FTP_d66e5297 from './json/c-FTP-d66e5297.js';
import c_FTP_d66e5321 from './json/c-FTP-d66e5321.js';
import c_HttpClientRequest_d66e5353 from './json/c-HttpClientRequest-d66e5353.js';
import c_HttpClientRequest_d66e5377 from './json/c-HttpClientRequest-d66e5377.js';
import c_HttpClientResponse_d66e5450 from './json/c-HttpClientResponse-d66e5450.js';
import c_HttpClientResponse_d66e5474 from './json/c-HttpClientResponse-d66e5474.js';
import c_HttpServletRequest_d66e7662 from './json/c-HttpServletRequest-d66e7662.js';
import c_HttpServletRequest_d66e7686 from './json/c-HttpServletRequest-d66e7686.js';
import c_HttpServletResponse_d66e7815 from './json/c-HttpServletResponse-d66e7815.js';
import c_HttpServletResponse_d66e7839 from './json/c-HttpServletResponse-d66e7839.js';
import c_HttpSoapConnection_d66e5506 from './json/c-HttpSoapConnection-d66e5506.js';
import c_HttpSoapConnection_d66e5530 from './json/c-HttpSoapConnection-d66e5530.js';
import c_MemoryBuffer_d66e5063 from './json/c-MemoryBuffer-d66e5063.js';
import c_MemoryBuffer_d66e5087 from './json/c-MemoryBuffer-d66e5087.js';
import c_Schema_d66e5975 from './json/c-Schema-d66e5975.js';
import c_Schema_d66e5999 from './json/c-Schema-d66e5999.js';
import c_SchemaKey_d66e6540 from './json/c-SchemaKey-d66e6540.js';
import c_SchemaKey_d66e6564 from './json/c-SchemaKey-d66e6564.js';
import c_SchemaNode_d66e6063 from './json/c-SchemaNode-d66e6063.js';
import c_SchemaNode_d66e6087 from './json/c-SchemaNode-d66e6087.js';
import c_SoapService_d66e5546 from './json/c-SoapService-d66e5546.js';
import c_SoapService_d66e5570 from './json/c-SoapService-d66e5570.js';
import c_WorkflowTask_d66e6774 from './json/c-WorkflowTask-d66e6774.js';
import c_WorkflowTask_d66e6798 from './json/c-WorkflowTask-d66e6798.js';
import c_ZipFile_d66e5232 from './json/c-ZipFile-d66e5232.js';
import c_ZipFile_d66e5256 from './json/c-ZipFile-d66e5256.js';

// Import all the s- files
import s_ncm_content_d66e1989 from './json/s-ncm-content-d66e1989.js';
import s_ncm_publishing_d66e2005 from './json/s-ncm-publishing-d66e2005.js';
import s_nl_monitoring_d66e1940 from './json/s-nl-monitoring-d66e1940.js';
import s_nms_address_d66e2103 from './json/s-nms-address-d66e2103.js';
import s_nms_asset_d66e2119 from './json/s-nms-asset-d66e2119.js';
import s_nms_budget_d66e2183 from './json/s-nms-budget-d66e2183.js';
import s_nms_centralCatalog_d66e2239 from './json/s-nms-centralCatalog-d66e2239.js';
import s_nms_cusResource_d66e2279 from './json/s-nms-cusResource-d66e2279.js';
import s_nms_delivery_d66e2311 from './json/s-nms-delivery-d66e2311.js';
import s_nms_deliveryOperation_d66e2820 from './json/s-nms-deliveryOperation-d66e2820.js';
import s_nms_eventHisto_d66e2844 from './json/s-nms-eventHisto-d66e2844.js';
import s_nms_extAccount_d66e2876 from './json/s-nms-extAccount-d66e2876.js';
import s_nms_gdprRequest_d66e2916 from './json/s-nms-gdprRequest-d66e2916.js';
import s_nms_gdprRequest_d66e2949 from './json/s-nms-gdprRequest-d66e2949.js';
import s_nms_group_d66e2957 from './json/s-nms-group-d66e2957.js';
import s_nms_group_d66e2981 from './json/s-nms-group-d66e2981.js';
import s_nms_localOrder_d66e3037 from './json/s-nms-localOrder-d66e3037.js';
import s_nms_localOrder_d66e3061 from './json/s-nms-localOrder-d66e3061.js';
import s_nms_localValidationLog_d66e3125 from './json/s-nms-localValidationLog-d66e3125.js';
import s_nms_localValidationLog_d66e3149 from './json/s-nms-localValidationLog-d66e3149.js';
import s_nms_localValidationTask_d66e3141 from './json/s-nms-localValidationTask-d66e3141.js';
import s_nms_localValidationTask_d66e3165 from './json/s-nms-localValidationTask-d66e3165.js';
import s_nms_mobileApp_d66e3157 from './json/s-nms-mobileApp-d66e3157.js';
import s_nms_mobileApp_d66e3181 from './json/s-nms-mobileApp-d66e3181.js';
import s_nms_newsgroup_d66e3213 from './json/s-nms-newsgroup-d66e3213.js';
import s_nms_newsgroup_d66e3237 from './json/s-nms-newsgroup-d66e3237.js';
import s_nms_offer_d66e3237 from './json/s-nms-offer-d66e3237.js';
import s_nms_offer_d66e3261 from './json/s-nms-offer-d66e3261.js';
import s_nms_offerCategory_d66e3309 from './json/s-nms-offerCategory-d66e3309.js';
import s_nms_offerCategory_d66e3333 from './json/s-nms-offerCategory-d66e3333.js';
import s_nms_offerSpace_d66e3341 from './json/s-nms-offerSpace-d66e3341.js';
import s_nms_offerSpace_d66e3366 from './json/s-nms-offerSpace-d66e3366.js';
import s_nms_operation_d66e3382 from './json/s-nms-operation-d66e3382.js';
import s_nms_operation_d66e3406 from './json/s-nms-operation-d66e3406.js';
import s_nms_predictiveModel_d66e3535 from './json/s-nms-predictiveModel-d66e3535.js';
import s_nms_predictiveModel_d66e3559 from './json/s-nms-predictiveModel-d66e3559.js';
import s_nms_privacyRequest_d66e2949 from './json/s-nms-privacyRequest-d66e2949.js';
import s_nms_purl_d66e3567 from './json/s-nms-purl-d66e3567.js';
import s_nms_purl_d66e3591 from './json/s-nms-purl-d66e3591.js';
import s_nms_recipient_d66e3599 from './json/s-nms-recipient-d66e3599.js';
import s_nms_recipient_d66e3623 from './json/s-nms-recipient-d66e3623.js';
import s_nms_remaHypothesis_d66e3639 from './json/s-nms-remaHypothesis-d66e3639.js';
import s_nms_remaHypothesis_d66e3663 from './json/s-nms-remaHypothesis-d66e3663.js';
import s_nms_remoteTracking_d66e3679 from './json/s-nms-remoteTracking-d66e3679.js';
import s_nms_remoteTracking_d66e3703 from './json/s-nms-remoteTracking-d66e3703.js';
import s_nms_rtEvent_d66e3751 from './json/s-nms-rtEvent-d66e3751.js';
import s_nms_rtEvent_d66e3775 from './json/s-nms-rtEvent-d66e3775.js';
import s_nms_seedMember_d66e3775 from './json/s-nms-seedMember-d66e3775.js';
import s_nms_seedMember_d66e3799 from './json/s-nms-seedMember-d66e3799.js';
import s_nms_simulation_d66e3791 from './json/s-nms-simulation-d66e3791.js';
import s_nms_simulation_d66e3815 from './json/s-nms-simulation-d66e3815.js';
import s_nms_stock_d66e3871 from './json/s-nms-stock-d66e3871.js';
import s_nms_stock_d66e3895 from './json/s-nms-stock-d66e3895.js';
import s_nms_subscription_d66e3887 from './json/s-nms-subscription-d66e3887.js';
import s_nms_subscription_d66e3912 from './json/s-nms-subscription-d66e3912.js';
import s_nms_supplier_d66e3936 from './json/s-nms-supplier-d66e3936.js';
import s_nms_supplier_d66e3960 from './json/s-nms-supplier-d66e3960.js';
import s_nms_task_d66e3960 from './json/s-nms-task-d66e3960.js';
import s_nms_task_d66e3984 from './json/s-nms-task-d66e3984.js';
import s_nms_trackingUrl_d66e4024 from './json/s-nms-trackingUrl-d66e4024.js';
import s_nms_trackingUrl_d66e4048 from './json/s-nms-trackingUrl-d66e4048.js';
import s_nms_typologyRule_d66e4080 from './json/s-nms-typologyRule-d66e4080.js';
import s_nms_typologyRule_d66e4104 from './json/s-nms-typologyRule-d66e4104.js';
import s_nms_visitor_d66e4096 from './json/s-nms-visitor-d66e4096.js';
import s_nms_visitor_d66e4120 from './json/s-nms-visitor-d66e4120.js';
import s_nms_webApp_d66e4112 from './json/s-nms-webApp-d66e4112.js';
import s_nms_webApp_d66e4136 from './json/s-nms-webApp-d66e4136.js';
import s_nms_webForm_d66e4217 from './json/s-nms-webForm-d66e4217.js';
import s_nms_webForm_d66e4241 from './json/s-nms-webForm-d66e4241.js';
import s_nms_workflow_d66e4265 from './json/s-nms-workflow-d66e4265.js';
import s_nms_workflow_d66e4289 from './json/s-nms-workflow-d66e4289.js';
import s_xtk_abstractForm_d66e79 from './json/s-xtk-abstractForm-d66e79.js';
import s_xtk_builder_d66e135 from './json/s-xtk-builder-d66e135.js';
import s_xtk_conflict_d66e361 from './json/s-xtk-conflict-d66e361.js';
import s_xtk_counter_d66e393 from './json/s-xtk-counter-d66e393.js';
import s_xtk_dataTransfer_d66e409 from './json/s-xtk-dataTransfer-d66e409.js';
import s_xtk_enum_d66e481 from './json/s-xtk-enum-d66e481.js';
import s_xtk_fileRes_d66e513 from './json/s-xtk-fileRes-d66e513.js';
import s_xtk_folder_d66e593 from './json/s-xtk-folder-d66e593.js';
import s_xtk_fusion_d66e681 from './json/s-xtk-fusion-d66e681.js';
import s_xtk_job_d66e705 from './json/s-xtk-job-d66e705.js';
import s_xtk_olapAggregate_d66e811 from './json/s-xtk-olapAggregate-d66e811.js';
import s_xtk_olapCube_d66e835 from './json/s-xtk-olapCube-d66e835.js';
import s_xtk_olapDimension_d66e964 from './json/s-xtk-olapDimension-d66e964.js';
import s_xtk_olapMeasure_d66e1012 from './json/s-xtk-olapMeasure-d66e1012.js';
import s_xtk_operator_d66e1028 from './json/s-xtk-operator-d66e1028.js';
import s_xtk_queryDef_d66e1052 from './json/s-xtk-queryDef-d66e1052.js';
import s_xtk_report_d66e1132 from './json/s-xtk-report-d66e1132.js';
import s_xtk_serverOptions_d66e1285 from './json/s-xtk-serverOptions-d66e1285.js';
import s_xtk_session_d66e1317 from './json/s-xtk-session-d66e1317.js';
import s_xtk_specFile_d66e1640 from './json/s-xtk-specFile-d66e1640.js';
import s_xtk_sql_d66e1664 from './json/s-xtk-sql-d66e1664.js';
import s_xtk_sqlSchema_d66e1681 from './json/s-xtk-sqlSchema-d66e1681.js';
import s_xtk_workflow_d66e1745 from './json/s-xtk-workflow-d66e1745.js';

// Create a map of all the imported modules
const navLinksData = {
  'nav-links': navLinks,
  'p-1-d66e21': p1d66e21,
  'tocId-d66e20': tocId_d66e20,
  'tocId-d66e69': tocId_d66e69,
  'tocId-d66e78': tocId_d66e78,
  'tocId-d66e1939': tocId_d66e1939,
  'tocId-d66e1988': tocId_d66e1988,
  'tocId-d66e2102': tocId_d66e2102,
  'tocId-d66e4297': tocId_d66e4297,
  'tocId-d66e4298': tocId_d66e4298,
  'tocId-d66e4321': tocId_d66e4321,
  'tocId-d66e4322': tocId_d66e4322,
  'tocId-d66e4428': tocId_d66e4428,
  'tocId-d66e4452': tocId_d66e4452,
  'tocId-d66e4517': tocId_d66e4517,
  'tocId-d66e4541': tocId_d66e4541,
  'tocId-d66e4550': tocId_d66e4550,
  'tocId-d66e4574': tocId_d66e4574,
  'tocId-d66e4809': tocId_d66e4809,
  'tocId-d66e4833': tocId_d66e4833,
  'tocId-d66e4842': tocId_d66e4842,
  'tocId-d66e4859': tocId_d66e4859,
  'tocId-d66e4860': tocId_d66e4860,
  'tocId-d66e4866': tocId_d66e4866,
  'tocId-d66e4883': tocId_d66e4883,
  'tocId-d66e4884': tocId_d66e4884,
  'tocId-d66e5296': tocId_d66e5296,
  'tocId-d66e5320': tocId_d66e5320,
  'tocId-d66e5618': tocId_d66e5618,
  'tocId-d66e5642': tocId_d66e5642,
  'tocId-d66e5780': tocId_d66e5780,
  'tocId-d66e5804': tocId_d66e5804,
  'tocId-d66e5974': tocId_d66e5974,
  'tocId-d66e5998': tocId_d66e5998,
  'tocId-d66e6716': tocId_d66e6716,
  'tocId-d66e6740': tocId_d66e6740,
  'tocId-d66e6773': tocId_d66e6773,
  'tocId-d66e6797': tocId_d66e6797,
  'tocId-d66e6862': tocId_d66e6862,
  'tocId-d66e6886': tocId_d66e6886,
  'tocId-d66e7555': tocId_d66e7555,
  'tocId-d66e7564': tocId_d66e7564,
  'tocId-d66e7579': tocId_d66e7579,
  'tocId-d66e7588': tocId_d66e7588,
  'tocId-d66e7589': tocId_d66e7589,
  'tocId-d66e7613': tocId_d66e7613,
  'tocId-d66e7864': tocId_d66e7864,
  'tocId-d66e7865': tocId_d66e7865,
  'tocId-d66e7866': tocId_d66e7866,
  'tocId-d66e7888': tocId_d66e7888,
  'tocId-d66e7889': tocId_d66e7889,
  'c-Application-d66e5781': c_Application_d66e5781,
  'c-Application-d66e5805': c_Application_d66e5805,
  'c-Cookie-d66e7590': c_Cookie_d66e7590,
  'c-Cookie-d66e7614': c_Cookie_d66e7614,
  'c-CurrentOperator-d66e5902': c_CurrentOperator_d66e5902,
  'c-CurrentOperator-d66e5926': c_CurrentOperator_d66e5926,
  'c-DBEngine-d66e5619': c_DBEngine_d66e5619,
  'c-DBEngine-d66e5643': c_DBEngine_d66e5643,
  'c-DOMAttr-d66e7443': c_DOMAttr_d66e7443,
  'c-DOMAttr-d66e7467': c_DOMAttr_d66e7467,
  'c-DOMCharacterData-d66e7491': c_DOMCharacterData_d66e7491,
  'c-DOMCharacterData-d66e7515': c_DOMCharacterData_d66e7515,
  'c-DOMDocument-d66e6863': c_DOMDocument_d66e6863,
  'c-DOMDocument-d66e6887': c_DOMDocument_d66e6887,
  'c-DOMElement-d66e7266': c_DOMElement_d66e7266,
  'c-DOMElement-d66e7290': c_DOMElement_d66e7290,
  'c-DOMNode-d66e7040': c_DOMNode_d66e7040,
  'c-DOMNode-d66e7064': c_DOMNode_d66e7064,
  'c-Entity-d66e6717': c_Entity_d66e6717,
  'c-Entity-d66e6741': c_Entity_d66e6741,
  'c-EntityCollection-d66e6733': c_EntityCollection_d66e6733,
  'c-EntityCollection-d66e6757': c_EntityCollection_d66e6757,
  'c-Enumeration-d66e6596': c_Enumeration_d66e6596,
  'c-Enumeration-d66e6620': c_Enumeration_d66e6620,
  'c-EnumerationValue-d66e6660': c_EnumerationValue_d66e6660,
  'c-EnumerationValue-d66e6684': c_EnumerationValue_d66e6684,
  'c-File-d66e4861': c_File_d66e4861,
  'c-File-d66e4885': c_File_d66e4885,
  'c-FTP-d66e5297': c_FTP_d66e5297,
  'c-FTP-d66e5321': c_FTP_d66e5321,
  'c-HttpClientRequest-d66e5353': c_HttpClientRequest_d66e5353,
  'c-HttpClientRequest-d66e5377': c_HttpClientRequest_d66e5377,
  'c-HttpClientResponse-d66e5450': c_HttpClientResponse_d66e5450,
  'c-HttpClientResponse-d66e5474': c_HttpClientResponse_d66e5474,
  'c-HttpServletRequest-d66e7662': c_HttpServletRequest_d66e7662,
  'c-HttpServletRequest-d66e7686': c_HttpServletRequest_d66e7686,
  'c-HttpServletResponse-d66e7815': c_HttpServletResponse_d66e7815,
  'c-HttpServletResponse-d66e7839': c_HttpServletResponse_d66e7839,
  'c-HttpSoapConnection-d66e5506': c_HttpSoapConnection_d66e5506,
  'c-HttpSoapConnection-d66e5530': c_HttpSoapConnection_d66e5530,
  'c-MemoryBuffer-d66e5063': c_MemoryBuffer_d66e5063,
  'c-MemoryBuffer-d66e5087': c_MemoryBuffer_d66e5087,
  'c-Schema-d66e5975': c_Schema_d66e5975,
  'c-Schema-d66e5999': c_Schema_d66e5999,
  'c-SchemaKey-d66e6540': c_SchemaKey_d66e6540,
  'c-SchemaKey-d66e6564': c_SchemaKey_d66e6564,
  'c-SchemaNode-d66e6063': c_SchemaNode_d66e6063,
  'c-SchemaNode-d66e6087': c_SchemaNode_d66e6087,
  'c-SoapService-d66e5546': c_SoapService_d66e5546,
  'c-SoapService-d66e5570': c_SoapService_d66e5570,
  'c-WorkflowTask-d66e6774': c_WorkflowTask_d66e6774,
  'c-WorkflowTask-d66e6798': c_WorkflowTask_d66e6798,
  'c-ZipFile-d66e5232': c_ZipFile_d66e5232,
  'c-ZipFile-d66e5256': c_ZipFile_d66e5256,
  's-ncm-content-d66e1989': s_ncm_content_d66e1989,
  's-ncm-publishing-d66e2005': s_ncm_publishing_d66e2005,
  's-nl-monitoring-d66e1940': s_nl_monitoring_d66e1940,
  's-nms-address-d66e2103': s_nms_address_d66e2103,
  's-nms-asset-d66e2119': s_nms_asset_d66e2119,
  's-nms-budget-d66e2183': s_nms_budget_d66e2183,
  's-nms-centralCatalog-d66e2239': s_nms_centralCatalog_d66e2239,
  's-nms-cusResource-d66e2279': s_nms_cusResource_d66e2279,
  's-nms-delivery-d66e2311': s_nms_delivery_d66e2311,
  's-nms-deliveryOperation-d66e2820': s_nms_deliveryOperation_d66e2820,
  's-nms-eventHisto-d66e2844': s_nms_eventHisto_d66e2844,
  's-nms-extAccount-d66e2876': s_nms_extAccount_d66e2876,
  's-nms-gdprRequest-d66e2916': s_nms_gdprRequest_d66e2916,
  's-nms-gdprRequest-d66e2949': s_nms_gdprRequest_d66e2949,
  's-nms-group-d66e2957': s_nms_group_d66e2957,
  's-nms-group-d66e2981': s_nms_group_d66e2981,
  's-nms-localOrder-d66e3037': s_nms_localOrder_d66e3037,
  's-nms-localOrder-d66e3061': s_nms_localOrder_d66e3061,
  's-nms-localValidationLog-d66e3125': s_nms_localValidationLog_d66e3125,
  's-nms-localValidationLog-d66e3149': s_nms_localValidationLog_d66e3149,
  's-nms-localValidationTask-d66e3141': s_nms_localValidationTask_d66e3141,
  's-nms-localValidationTask-d66e3165': s_nms_localValidationTask_d66e3165,
  's-nms-mobileApp-d66e3157': s_nms_mobileApp_d66e3157,
  's-nms-mobileApp-d66e3181': s_nms_mobileApp_d66e3181,
  's-nms-newsgroup-d66e3213': s_nms_newsgroup_d66e3213,
  's-nms-newsgroup-d66e3237': s_nms_newsgroup_d66e3237,
  's-nms-offer-d66e3237': s_nms_offer_d66e3237,
  's-nms-offer-d66e3261': s_nms_offer_d66e3261,
  's-nms-offerCategory-d66e3309': s_nms_offerCategory_d66e3309,
  's-nms-offerCategory-d66e3333': s_nms_offerCategory_d66e3333,
  's-nms-offerSpace-d66e3341': s_nms_offerSpace_d66e3341,
  's-nms-offerSpace-d66e3366': s_nms_offerSpace_d66e3366,
  's-nms-operation-d66e3382': s_nms_operation_d66e3382,
  's-nms-operation-d66e3406': s_nms_operation_d66e3406,
  's-nms-predictiveModel-d66e3535': s_nms_predictiveModel_d66e3535,
  's-nms-predictiveModel-d66e3559': s_nms_predictiveModel_d66e3559,
  's-nms-privacyRequest-d66e2949': s_nms_privacyRequest_d66e2949,
  's-nms-purl-d66e3567': s_nms_purl_d66e3567,
  's-nms-purl-d66e3591': s_nms_purl_d66e3591,
  's-nms-recipient-d66e3599': s_nms_recipient_d66e3599,
  's-nms-recipient-d66e3623': s_nms_recipient_d66e3623,
  's-nms-remaHypothesis-d66e3639': s_nms_remaHypothesis_d66e3639,
  's-nms-remaHypothesis-d66e3663': s_nms_remaHypothesis_d66e3663,
  's-nms-remoteTracking-d66e3679': s_nms_remoteTracking_d66e3679,
  's-nms-remoteTracking-d66e3703': s_nms_remoteTracking_d66e3703,
  's-nms-rtEvent-d66e3751': s_nms_rtEvent_d66e3751,
  's-nms-rtEvent-d66e3775': s_nms_rtEvent_d66e3775,
  's-nms-seedMember-d66e3775': s_nms_seedMember_d66e3775,
  's-nms-seedMember-d66e3799': s_nms_seedMember_d66e3799,
  's-nms-simulation-d66e3791': s_nms_simulation_d66e3791,
  's-nms-simulation-d66e3815': s_nms_simulation_d66e3815,
  's-nms-stock-d66e3871': s_nms_stock_d66e3871,
  's-nms-stock-d66e3895': s_nms_stock_d66e3895,
  's-nms-subscription-d66e3887': s_nms_subscription_d66e3887,
  's-nms-subscription-d66e3912': s_nms_subscription_d66e3912,
  's-nms-supplier-d66e3936': s_nms_supplier_d66e3936,
  's-nms-supplier-d66e3960': s_nms_supplier_d66e3960,
  's-nms-task-d66e3960': s_nms_task_d66e3960,
  's-nms-task-d66e3984': s_nms_task_d66e3984,
  's-nms-trackingUrl-d66e4024': s_nms_trackingUrl_d66e4024,
  's-nms-trackingUrl-d66e4048': s_nms_trackingUrl_d66e4048,
  's-nms-typologyRule-d66e4080': s_nms_typologyRule_d66e4080,
  's-nms-typologyRule-d66e4104': s_nms_typologyRule_d66e4104,
  's-nms-visitor-d66e4096': s_nms_visitor_d66e4096,
  's-nms-visitor-d66e4120': s_nms_visitor_d66e4120,
  's-nms-webApp-d66e4112': s_nms_webApp_d66e4112,
  's-nms-webApp-d66e4136': s_nms_webApp_d66e4136,
  's-nms-webForm-d66e4217': s_nms_webForm_d66e4217,
  's-nms-webForm-d66e4241': s_nms_webForm_d66e4241,
  's-nms-workflow-d66e4265': s_nms_workflow_d66e4265,
  's-nms-workflow-d66e4289': s_nms_workflow_d66e4289,
  's-xtk-abstractForm-d66e79': s_xtk_abstractForm_d66e79,
  's-xtk-builder-d66e135': s_xtk_builder_d66e135,
  's-xtk-conflict-d66e361': s_xtk_conflict_d66e361,
  's-xtk-counter-d66e393': s_xtk_counter_d66e393,
  's-xtk-dataTransfer-d66e409': s_xtk_dataTransfer_d66e409,
  's-xtk-enum-d66e481': s_xtk_enum_d66e481,
  's-xtk-fileRes-d66e513': s_xtk_fileRes_d66e513,
  's-xtk-folder-d66e593': s_xtk_folder_d66e593,
  's-xtk-fusion-d66e681': s_xtk_fusion_d66e681,
  's-xtk-job-d66e705': s_xtk_job_d66e705,
  's-xtk-olapAggregate-d66e811': s_xtk_olapAggregate_d66e811,
  's-xtk-olapCube-d66e835': s_xtk_olapCube_d66e835,
  's-xtk-olapDimension-d66e964': s_xtk_olapDimension_d66e964,
  's-xtk-olapMeasure-d66e1012': s_xtk_olapMeasure_d66e1012,
  's-xtk-operator-d66e1028': s_xtk_operator_d66e1028,
  's-xtk-queryDef-d66e1052': s_xtk_queryDef_d66e1052,
  's-xtk-report-d66e1132': s_xtk_report_d66e1132,
  's-xtk-serverOptions-d66e1285': s_xtk_serverOptions_d66e1285,
  's-xtk-session-d66e1317': s_xtk_session_d66e1317,
  's-xtk-specFile-d66e1640': s_xtk_specFile_d66e1640,
  's-xtk-sql-d66e1664': s_xtk_sql_d66e1664,
  's-xtk-sqlSchema-d66e1681': s_xtk_sqlSchema_d66e1681,
  's-xtk-workflow-d66e1745': s_xtk_workflow_d66e1745
};

export default navLinksData;
